import {Component, Input} from '@angular/core'
import {StaticComponentInstance} from '../../static-form/static-form.types'
import {FormControl, Validators} from '@angular/forms'
import {
  ParquetMaintenance_ParquetCondition,
  ParquetMaintenanceStaticJobQuestionsInput,
  StaticJobQuestionsInput,
} from '../../../../../../../__generated__/types'
import {TypedFormGroup} from '../../../../../../core/forms/form-controls.model'

@Component({
  templateUrl: './parquet-maintenance-static-form.component.html',
  styleUrls: ['../../gradual-reveal.css'],
})
export class ParquetMaintenanceStaticFormComponent implements StaticComponentInstance {
  @Input({required: true}) form!: TypedFormGroup<ParquetMaintenanceStaticJobQuestionsInput>

  protected readonly ParquetMaintenance_ParquetCondition = ParquetMaintenance_ParquetCondition

  public static createForm(): TypedFormGroup<ParquetMaintenanceStaticJobQuestionsInput> {
    return new TypedFormGroup<ParquetMaintenanceStaticJobQuestionsInput>({
      condition: new FormControl(undefined, [Validators.required]),
      sizeOfFloor: new FormControl(undefined, [Validators.required]),
      skirtingBoardLength: new FormControl(undefined, [Validators.required]),
      areSkirtingBoardsGlued: new FormControl(undefined, [Validators.required]),
      areThereObstaclesOnTheFloor: new FormControl(undefined, [Validators.required]),
      hasBeenSandedBefore: new FormControl(undefined, [Validators.required]),
      age: new FormControl(undefined),
      material: new FormControl(undefined),
    })
  }

  questionsInput(): StaticJobQuestionsInput {
    return {
      parquetMaintenance: {
        condition: this.form?.value.condition || ParquetMaintenance_ParquetCondition.NormalWearAndTear,
        sizeOfFloor: this.form?.value.sizeOfFloor || 0,
        skirtingBoardLength: this.form?.value.skirtingBoardLength || 0,
        areSkirtingBoardsGlued: this.form?.value.areSkirtingBoardsGlued,
        areThereObstaclesOnTheFloor: this.form?.value.areThereObstaclesOnTheFloor,
        hasBeenSandedBefore: this.form?.value.hasBeenSandedBefore,
        // unused fields
        age: this.form?.value.age,
        material: this.form?.value.material,
      },
    }
  }
}
